<template>
  <v-container>
    <v-col v-for="field in fields" v-bind:key="field.index">
      <v-row
        ><v-text-field
          @change="onAdd"
          v-model="field.value"
          class="mb-n2 mr-4 ml-2"
        ></v-text-field>
        <v-btn
          fab
          dark
          small
          color="secondary"
          @click="onPlus"
          @hover="console.log('hi')"
          ><v-icon>mdi-plus-thick</v-icon></v-btn
        ></v-row
      >
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "addingTextField",
  data: () => ({
    fields: [{ index: 0, value: "" }]
  }),
  methods: {
    onAdd() {
      console.log(this.fields);
      this.$emit("added", this.fields);
    },
    onPlus() {
      this.fields.push({ index: this.fields.length, value: "" });
    }
  }
};
</script>

<style scoped></style>
